/** @jsx jsx */
import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import {jsx} from 'theme-ui'
import FsLightbox from 'fslightbox-react'
import SectionHeading from '../SectionHeading'
import Button from "../Button/button"
import IconButton from "../Button/IconButton"
// Icons
import Add from "../../icons/add.svg"
import Layout from "../layout"

const GalleryContainer = props => (
    <div sx={{
        display: 'grid',
        gridTemplateColumns: ['1fr 1fr', '1fr 1fr 1fr', '1fr 1fr 1fr 1fr'],
        columnGap: '0.5rem',
        rowGap: '0.5rem',

        '> *': {
            borderRadius: 1
        }
    }}>{props.children}</div>
)

class Gallery extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: props.visibleImages,
            toggler: false,
            sourceIndex: 1
        }
    }


    componentDidUpdate() {
        if(this.state.visible>this.props.visibleImages) {this.handleScrollPosition()}
        else {
            window.scrollTo(0, sessionStorage.getItem("scrollPosition"));
        }
    }

    // https://stackoverflow.com/questions/59100931/maintaining-state-and-scroll-position-in-react
    handleScrollPosition = () => {
        const scrollPosition = sessionStorage.getItem("scrollPosition");
        window.scrollTo(0, scrollPosition);
    };
    
    // store position in sessionStorage
    handleClick = data => {  
        if(this.state.visible<=this.props.visibleImages) {
            this.setState({visible: data.allFile.edges.length});
            sessionStorage.setItem("scrollPosition", window.scrollY);
        } else {
            this.setState({visible: this.props.visibleImages})
        }
    };

    openLightboxOnSlide(number) {
        this.setState({
            toggler: !this.state.toggler,
            sourceIndex: number
        })
    }

    render() {
        let srcPaths = []

        return (
            <StaticQuery
            query={graphql`
            {
                allFile(
                    sort: {fields: name, order: ASC}
                    filter: {
                        extension: { regex: "/(jpg)|(png)|(jpeg)/" },
                        sourceInstanceName: {eq: "gallery"}
                    }
                ) {
                    edges {
                        node {
                            base
                            childImageSharp {
                                resize {
                                    height
                                }
                                fluid(maxWidth: 300, maxHeight: 300) {
                                    ...GatsbyImageSharpFluid
                                    originalImg
                                    srcWebp
                                }
                            }
                        }
                    }
                }
            }
            `}
            render={data => (
            <div sx={{textAlign: 'center', bg: 'white', py: [7,7,9]}} id={this.props.id}>
                <Layout>
                    <SectionHeading caption="Check our popular dishes" textAlign="center">Gallery</SectionHeading>
                    <GalleryContainer>
                            {data.allFile.edges.map((image, index) => {
                                srcPaths.push(image.node.childImageSharp.fluid.originalImg)

                                return (
                                    <div role="button" onKeyDown={() => this.openLightboxOnSlide(index)} onClick={() => this.openLightboxOnSlide(index)} tabIndex="0" key={index} aria-label="Image ${index}">
                                        <Img
                                        key={index}
                                        fluid={image.node.childImageSharp.fluid}
                                        alt={image.node.base.split(".")[0]}
                                        imgStyle={{transition: '0.2s ease-in-out transform',}}
                                        sx={{
                                            borderRadius: 1, 
                                            cursor: 'pointer',
                                            overflow: 'hidden',

                                            '&:hover img:hover': {
                                                transition: '0.2s ease-in-out transform',
                                                borderWidth: '10px',
                                                transform: 'scale(1.1)'
                                            }
                                        }}
                                    />
                                    </div>                                    
                                    )}).slice(0,this.state.visible)
                            }
                            <FsLightbox
                                toggler={this.state.toggler}
                                sources={srcPaths}
                                sourceIndex={this.state.sourceIndex}
                            />
                    </GalleryContainer>
                        
                    <div sx={{my: 5}}><Button variant="secondary" onClick={() => this.handleClick(data)}>
                        <IconButton><Add sx={{transition: '0.2s ease-in-out transform',transform: `${this.state.visible<=this.props.visibleImages ? 'rotateZ(0deg)' : 'rotateZ(45deg)'}`}} /></IconButton> <span>{this.state.visible<=this.props.visibleImages ? "Show more images" : "Show fewer images"}</span></Button></div>
                </Layout>
            </div>
            )}
            />
        )
    }
}

export default Gallery

Gallery.defaultProps = {
    visibleImages: 4
}